// extracted by mini-css-extract-plugin
export default {"controls":"NewsweekWidget_controls__UvwGE","controls__ended":"NewsweekWidget_controls__ended__RsVj2","button":"NewsweekWidget_button__LTZzy"};